var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2PreciseSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7 37a6.84 6.84 0 00-13.07 0H14v4h30.63a6.84 6.84 0 0013.07 0H62v-4h-4.3zm-4.53 4a2.82 2.82 0 11-3.98-3.997A2.82 2.82 0 0153.17 41zM40.31 22a6.82 6.82 0 00-13 0H14v4h13.26a6.82 6.82 0 0013.15 0H62v-4H40.31zM36 26a2.829 2.829 0 01-4-4 2.77 2.77 0 013.61 0 2.79 2.79 0 01.39 4zm-4.59 26a6.82 6.82 0 00-13.15 0 6.531 6.531 0 00-.26 1.83c0 .738.122 1.471.36 2.17a6.82 6.82 0 0013 0H62v-4H31.41zm-4.77 4a2.79 2.79 0 111-2.17 2.82 2.82 0 01-1 2.17z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Precise_settings.a97f499c.svg";
export { SvgJ2PreciseSettings as ReactComponent };